export default function ReportInstanceCommentDirective() {
  return {
    template: require('./report-instance-comment.html'),
    scope: {
      reportInstanceComment: '=',
    },
    controller: 'GRReportInstanceCommentController',
    controllerAs: 'grReportInstanceCommentVM',
    bindToController: true,
    replace: true
  };
}
